// @ts-nocheck

// App
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// Actions
import AdActions from 'app/shared/flux/actions/AdActions';
import AreaActions from 'app/shared/flux/actions/AreaActions';
import ErrorActions from 'app/shared/flux/actions/ErrorActions';
import { FilterActions_initFilterWithExperimentState } from 'app/shared/flux/actions/FilterActions';
import ListingEngineActions from 'app/shared/flux/actions/ListingEngineActions';

// Components
import AreaPage from 'app/shared/pages/AreaPage';
import FilterNav from 'app/shared/modules/navigation/FilterNav';

// Misc / Utils
import constants from 'app/shared/constants/ConstantsBundle';
import controller from 'app/shared/wrappers/FetchAreaWrapper/controller';
import queryUtils from 'app/shared/utils/queryUtils';
import routeUtils from 'app/shared/utils/routeUtils';

// Lodash
import isEmpty from 'lodash/isEmpty';

// serverRouteWillMount functions
import loadGeolocation from 'app/shared/wrappers/FetchAreaWrapper/loadGeolocation';
import loadAreaPage from 'app/shared/wrappers/FetchAreaWrapper/loadAreaPage';
import resolveFetchListingsPromises from 'app/shared/wrappers/FetchAreaWrapper/resolveFetchListingsPromises';
import loadAreaSeoLinks from 'app/shared/wrappers/FetchAreaWrapper/loadAreaSeoLinks';
import loadFilterFromUrlAndApi from 'app/shared/wrappers/FetchAreaWrapper/loadFilterFromUrlAndApi';
import { emitTrackViewSrpEvent } from 'app/shared/models/Clickstream/PageViewEvents';
import { getGlobalLogger } from '@zg-rentals/logger-base';
import { logError } from '@zg-rentals/log-error';

const logger = getGlobalLogger('wrappers/fetchArea');

class FetchAreaWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.additionalDataTimer = null;
    this.TIMEOUT_LENGTH_MS = 2000;
  }

  componentDidMount() {
    const { area, dispatch, geolocation, isClientSideLoadedPage, isMobile, pathname, query } = this.props;

    const { areaResourceId } = controller.getAreaSeoInfo(pathname);
    // current area does not match the url
    // clear the current area before fetching new one
    // this acts as an "area loading" mechanism (shows skeleton)
    if (!routeUtils.isNearMeUrl(areaResourceId) && areaResourceId !== area.resourceId) {
      dispatch(AreaActions.clearCurrentArea());
    }

    const hasLatAndLon = routeUtils.hasLatAndLon(query);
    const areaMustBeDerivedFromMap = !isMobile && hasLatAndLon;

    const isMapView = !isMobile; // on mWeb, the area page defaults to list view
    const isNearMeUrl = routeUtils.isNearMeUrl(areaResourceId);
    const geoOrAreaResourceId = isNearMeUrl && !isEmpty(geolocation) ? geolocation.resourceId : areaResourceId;

    if (isClientSideLoadedPage || areaMustBeDerivedFromMap) {
      dispatch(AreaActions.loadAreaPage(geoOrAreaResourceId, isMapView))
        .then((res) => {
          if (res === Object(res) && res.error && res.to) {
            return res;
          }

          return true;
        })
        .then((res) => {
          if (res === Object(res) && res.error && res.to) {
            return window.router.redirectTo(res.to);
          }

          const forceAdRefresh = true;
          dispatch(AdActions.refreshAd(forceAdRefresh));

          return this.setAdditionalDataTimer();
        })
        .catch((error) => {
          dispatch(
            ErrorActions.errorHandler({
              error,
              errorLocation: 'component.fetchAreaWrapper.componentDidMount#loadAreaPage',
              errorClass: 'areaActions',
            }),
          );
        });
    } else {
      emitTrackViewSrpEvent();
    }
  }

  componentDidUpdate(prevProps) {
    const { dispatch, currentPage, query } = this.props;

    // track page view changes in analytics
    if (prevProps.currentPage && currentPage && prevProps.currentPage !== currentPage) {
      emitTrackViewSrpEvent();
    }

    // Check if experiment parameters have changed and reinitialize filter if needed
    const prevQuery = prevProps.query || {};
    const currentHasExperiment = query.HPWEB_EXP || query.HPWEB_CONTROL;
    const prevHasExperiment = prevQuery.HPWEB_EXP || prevQuery.HPWEB_CONTROL;

    // If experiment parameters changed (added, removed, or modified), reinitialize filter
    if (query.HPWEB_EXP !== prevQuery.HPWEB_EXP || query.HPWEB_CONTROL !== prevQuery.HPWEB_CONTROL) {
      // Dispatch action to initialize filter with current experiment state
      dispatch(FilterActions_initFilterWithExperimentState());
    }
  }

  componentWillUnmount() {
    this.cancelAdditionalDataTimer();
  }
  serverRouteWillMount(reactContext) {
    const { store } = reactContext;
    const { pathname } = reactContext.state;
    const state = store.getState();

    const { areaResourceId } = controller.getAreaSeoInfo(pathname);
    const trace = reactContext.trace;
    const fetchData = [];
    const fetchAsyncAreaData = (resourceId = 'new-york-ny') => {
      trace.startAsyncSpan({ marker: 'FetchAreaWrapper#fetchDataPromiseArray' });
      trace.startAsyncSpan({ marker: 'FetchAreaWrapper#AreaActions#loadAreaPage' });
      trace.startAsyncSpan({ marker: 'FetchAreaWrapper#FilterActions#loadFilterFromUrlAndApi' });

      const beforeFetchListings = [];
      // fetchListings relies on the `filter` and `area`
      beforeFetchListings.push(
        loadFilterFromUrlAndApi(reactContext),
        loadAreaPage(reactContext, { areaResourceId: resourceId }),
      );

      fetchData.push(resolveFetchListingsPromises(reactContext, beforeFetchListings));

      // note: never called - waiting on V3
      // trace.startAsyncSpan({ marker: 'FetchAreaWrapper#AreaActions#loadAreaBlogPosts' });
      // fetchData.push(loadAreaBlogPosts(reactContext, { areaResourceId: resourceId }));

      trace.startAsyncSpan({ marker: 'FetchAreaWrapper#AreaActions#loadAreaSeoLinks' });
      fetchData.push(loadAreaSeoLinks(reactContext, { areaResourceId: resourceId }));

      return Promise.all(fetchData)
        .then((responses = []) => {
          trace.finishAsyncSpan({ marker: 'FetchAreaWrapper#fetchDataPromiseArray' });

          return responses;
        })
        .catch((error) => {
          logger.warn({
            error,
            msg: 'AreaActions.loadAreaPage#Promise.all',
            pathname,
            resourceId: areaResourceId,
            requestId: state.app.requestId,
          });
        });
    };

    if (routeUtils.isNearMeUrl(areaResourceId)) {
      trace.startAsyncSpan({ marker: 'FetchAreaWrapper#loadGeolocationData' });
      return loadGeolocation(reactContext).then((geoData) => {
        // IP address might be out of range for `area/byIp` endpoint
        if (geoData === false) {
          logError({
            error: 'FetchAreaWrapper.serverRouteWillMount.geoPromise',
            errorType: 'FetchAreaWrapperError',
            context: `No geocode for IP ${reactContext.ip}`,
          });
          return fetchAsyncAreaData();
        }
        const geoDataId = geoData.area && geoData.area.resourceId;

        return fetchAsyncAreaData(geoDataId);
      });
    }

    return fetchAsyncAreaData(areaResourceId);
  }
  // delay getting more information about the area
  // if the user got here via client side transition
  // until they have been on the page for this.TIMEOUT_LENGTH_MS
  setAdditionalDataTimer = () => {
    this.additionalDataTimer = setTimeout(this.getAdditionalAreaData, this.TIMEOUT_LENGTH_MS);
  };

  cancelAdditionalDataTimer = () => {
    if (this.additionalDataTimer) {
      clearTimeout(this.additionalDataTimer);
    }
  };

  getAdditionalAreaData = () => {
    const { dispatch, geolocation, pathname } = this.props;
    const { areaResourceId, searchSlug } = controller.getAreaSeoInfo(pathname);
    const isNearMeUrl = routeUtils.isNearMeUrl(areaResourceId);
    const geoOrAreaResourceId = isNearMeUrl && !isEmpty(geolocation) ? geolocation.resourceId : areaResourceId;

    const maxBuildings = this.props.totalBuildings;
    const maxPage = Math.max(Math.ceil(maxBuildings / constants.MAX_LISTINGS_PER_PAGE), 1);
    const currentPage = this.props.location.current && this.props.location.current.query.page;
    const onLastPage = maxPage === Number(currentPage);

    if (onLastPage) {
      dispatch(ListingEngineActions.fetchNearbyAreasListings(geoOrAreaResourceId)).catch((error) => {
        dispatch(
          ErrorActions.errorHandler({
            error,
            errorLocation: 'component.fetchAreaWrapper.componentDidMount#fetchNearbyAreasListings',
            errorClass: 'listingEngineActions',
          }),
        );
      });
    }

    dispatch(AreaActions.loadAreaSeoLinks({ resourceId: geoOrAreaResourceId, searchSlug })).catch((error) => {
      dispatch(
        ErrorActions.errorHandler({
          error,
          errorLocation: 'component.fetchAreaWrapper.componentDidMount#loadAreaSeoLinks',
          errorClass: 'areaActions',
        }),
      );
    });

    emitTrackViewSrpEvent();

    this.additionalDataTimer = null;
  };

  render() {
    const { advancedFilterVisible, isClientSideLoadedPage, listingsLoading, area } = this.props;
    const areaIsLoading = isClientSideLoadedPage ? !area.resourceId : false;
    const showSkeletonPage = (areaIsLoading || listingsLoading) && isClientSideLoadedPage;

    return (
      <>
        <FilterNav advancedFilterVisible={advancedFilterVisible} />
        <AreaPage showSkeletonPage={showSkeletonPage} />
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  advancedFilterVisible: state.app.advancedFilterVisible,
  area: state.area.area,
  currentPage: Number(state.location?.current?.query?.page) || 1,
  geolocation: state.geolocation.area,
  isClientSideLoadedPage: state.app.isClientSideLoadedPage,
  isInitialSsrPage: state.app.isInitialSsrPage,
  isMobile: state.app.device.screenWidth === 'sm',
  listings: state.listings.listingGroups.byCoords,
  listingsLoading: !state.app.fetchListingsByCoordsComplete,
  totalBuildings: state.listings.totalBuildings,
  isMapPanning: state.app.isMapPanning,
  location: ownProps.location,
  pathname: ownProps.location.pathname,
  query: queryUtils.parse(ownProps.location.search),
});

export default withRouter(connect(mapStateToProps)(FetchAreaWrapper));
